export default __webpack_public_path__ + "static/media/S_Sapato.92c2fcd8.mp3";